import { z } from 'zod';
import { emailSchema, senhaSchema } from '../auth/equipe.js';
/** Cadastro da equipe. A senha nunca é definida pelo admin: o usuário recebe um convite. */
export const PapelSetorValores = ['atendente', 'supervisor'];
export const vinculoSetorSchema = z.object({
    setorId: z.uuid(),
    papel: z.enum(PapelSetorValores).default('atendente'),
    /**
     * 0 = setor principal desta pessoa; 1, 2… = secundário, terciário.
     *
     * A fila de um setor entrega primeiro a quem o tem como principal. Alguém do Suporte que
     * também cobre a Liberação só recebe da Liberação quando ninguém de lá estiver
     * disponível — assim o setor principal dele não fica descoberto.
     */
    ordem: z.coerce.number().int().min(0).max(9).default(0),
});
export const usuarioFormSchema = z.object({
    nome: z.string().trim().min(3, 'Informe o nome completo').max(120),
    email: emailSchema,
    perfilId: z.uuid('Escolha um perfil'),
    limiteSimultaneo: z.coerce.number().int().min(1).max(50).default(5),
    ativo: z.boolean().default(true),
    setores: z.array(vinculoSetorSchema).default([]),
});
export const definirSenhaConviteSchema = z
    .object({
    token: z.string().min(10),
    senha: senhaSchema,
    confirmacao: z.string(),
})
    .refine((d) => d.senha === d.confirmacao, {
    message: 'As senhas não conferem',
    path: ['confirmacao'],
});
// ---- perfis ----------------------------------------------------------------
export const VisibilidadeValores = ['oculto', 'mascarado', 'completo'];
export const perfilFormSchema = z.object({
    nome: z.string().trim().min(2, 'Informe o nome do perfil').max(60),
    descricao: z.string().trim().max(200).optional().or(z.literal('')),
    permissoes: z.array(z.string()).min(1, 'Escolha ao menos uma permissão'),
    /** false (padrão): o perfil vê todos os motivos e respostas. */
    restringirCatalogos: z.boolean().default(false),
    /** Só valem quando restringirCatalogos = true. */
    motivosPermitidos: z.array(z.uuid()).default([]),
    mensagensPermitidas: z.array(z.uuid()).default([]),
    visibilidadeCampos: z.object({
        nome: z.enum(VisibilidadeValores),
        cpf: z.enum(VisibilidadeValores),
        telefone: z.enum(VisibilidadeValores),
        email: z.enum(VisibilidadeValores),
        endereco: z.enum(VisibilidadeValores),
    }),
});
//# sourceMappingURL=usuarios.js.map